module.exports = __webpack_public_path__ + "static/media/Bicocca - Ind.Blue_White.42862bf8.jpg";